import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BookList from './components/BookList';
import BookShelf from './components/BookShelf';
import BookDetails from './components/BookDetails';
import api from './services/api';
import './App.css';

function App() {
  useEffect(() => {
    api.telegram.ready();
    api.telegram.expand();
  }, []);

  return (
    <BrowserRouter>
      <div className="app">
        <div className="app-content">
          <Routes>
            <Route path="/" element={<BookList />} />
            <Route path="/shelf/:id" element={<BookShelf />} />
            <Route path="/book/:id" element={<BookDetails />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App; 